import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {helloWorld as helloWorldAction} from "../actions/helloWorld";

export const HelloWorld = () => {
	const dispatch = useDispatch();
	const triggerHelloWorld = () => dispatch(helloWorldAction());
	const message = useSelector((state) => state.helloWorld.message);
	//
	// if already login, redirect to homepage
	// use history hook to redirect/navigate between routes
	// component did mount
	useEffect(() => {
		triggerHelloWorld();
	}, []);

	return (
		<div>{message}</div>
	);
};
